import { SharedErrors } from 'web_core_library';
import { NO_ALERT_TYPE } from '../base/types';

// properties of the workout in session
export interface IWorkoutStats {
  exerciseName: string;
  locked: boolean;
  comparison: number;
  goal: number;
  // workout ids from the same categoryGroupId
  siblings: number[];
}

export interface ISessionWorkoutStats {
  [workoutId: number]: IWorkoutStats;
}

export interface ITrainingWorkoutState {
  workoutId: number;
  goal: number;
  reachDifficulty: number;
  startDifficulty: number;
  timestamp: number;
}

export interface ITrainingWorkoutStateResponse {
  trainingworkoutstate: ITrainingWorkoutState[];
}

export interface IDifficultyFadeFactor {
  days: number;
  factor: number;
}

export class SessionError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, SessionError.prototype);
    this.errorType = NO_ALERT_TYPE;
    this.feature = 'Session';
  }
}

export class SessionCacheError extends SessionError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, SessionCacheError.prototype);
    this.feature = 'Session_cache';
  }
}

export interface IUpdateWorkoutStatsPayload {
  workoutId: number;
  stats: Partial<IWorkoutStats>;
}

export interface ISaveWorkoutStatePayload {
  workoutId: number;
  goal: number;
  startDifficulty: number;
  reachDifficulty: number;
}

export interface IUpdateWorkoutComparisonPayload {
  workoutId: number;
  comparison: number;
}
